import { render, staticRenderFns } from "./yjdcimporterror.vue?vue&type=template&id=27c82699&scoped=true&"
import script from "./yjdcimporterror.vue?vue&type=script&lang=js&"
export * from "./yjdcimporterror.vue?vue&type=script&lang=js&"
import style0 from "./yjdcimporterror.vue?vue&type=style&index=0&id=27c82699&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c82699",
  null
  
)

export default component.exports